// HKDSE Type B (語錄體) Q&A Data
// B1. 《論語》論仁
// B3. 《論語》論君子

export const hkdseTypeBQAData = {
  'hkdse-b1-analects-ren': {
    title: '《論語》論仁問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落重點整理',
        content: [
          {
            subtitle: '論仁',
            points: [
              {
                title: '仁者安貧樂道',
                items: ['仁者安於當下，即使貧苦也能安之若素。']
              },
              {
                title: '仁者與智者的分別',
                items: ['仁者由心而仁，智者則著重利益。']
              },
              {
                title: '君子對待貧富的態度',
                items: [
                  '君子只會依循正道得富貴，絕不以不正當手段求取財富地位；',
                  '不以不正當方法擺脫貧苦。'
                ]
              },
              {
                title: '實踐仁的方法',
                items: ['克己復禮，非禮勿視、勿聽、勿言、勿動。']
              },
              {
                title: '仁的最高層次',
                items: ['不以生存損害仁德，甚至可犧牲生命成全仁德。']
              }
            ]
          },
          {
            subtitle: '論孝',
            points: [
              {
                title: '孝的定義',
                items: ['「無違」——不違禮節。']
              },
              {
                title: '行孝方式',
                items: ['「生，事之以禮；死，葬之以禮，祭之以禮。」對父母在生時依禮侍奉，死後依禮祭祀安葬。']
              },
              {
                title: '供養要敬',
                items: ['供養父母必須心存敬意，否則與飼養犬馬無異。']
              },
              {
                title: '父母有過應如何',
                items: ['委婉勸諫，父母不聽仍要恭敬，不可違逆，內心雖憂卻不怨。']
              },
              {
                title: '記掛父母年歲',
                items: ['一則以喜，一則以懼——既為他們長壽而高興，亦因其年老而憂心。']
              }
            ]
          },
          {
            subtitle: '論君子',
            points: [
              {
                title: '君子的特質',
                items: ['莊重、努力學習、忠信、慎選朋友。']
              },
              {
                title: '心理狀態',
                items: ['君子坦蕩蕩，不憂不懼，因為常自省，問心無愧。']
              },
              {
                title: '行事準則',
                items: ['以道義為本，按禮行事，謙遜誠實，勇於改過。']
              },
              {
                title: '對待他人',
                items: ['成全他人之美，不促成他人之惡。']
              },
              {
                title: '君子與小人的分別',
                items: ['君子光明磊落，小人多疑憂慮；君子責己，小人責人。']
              }
            ]
          }
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '試說明《論語》的體裁特點。',
            answer: '《論語》屬語錄體，直接記錄孔子及弟子的言語，將精要語句編入各篇章。語錄體重內容而非文采，文字簡潔貼近日常口語，便於理解，而且言簡意賅，主旨鮮明，無多餘背景敘述，讀者可多角度領會其意。'
          },
          {
            question: '孔子認為仁者在面對貧富、守禮及生死三方面應有何表現？',
            answer: '面對貧富：仁者安於現狀，只求遵行仁道，不會為富貴違背仁德，也不為脫貧不擇手段。守禮：仁者克己復禮，言行舉止皆合乎禮，非禮勿視、勿聽、勿言、勿動。生死觀：仁者視仁德比生命重要，寧可犧牲生命成全仁德，不會為苟活而損害仁德。'
          },
          {
            question: '孟懿子、樊遲及子游問孝，孔子如何回應？這顯示孔子教學有何特點？',
            answer: '孟懿子問孝，孔子簡明答「無違」（不違禮）。樊遲追問，孔子詳細說明要「生事之以禮；死葬之以禮，祭之以禮」。子游問孝，孔子則強調要有敬意，否則與飼養犬馬無異。特點：孔子因材施教，根據學生身分背景及提問內容，分別選擇簡明或詳細的回答，並著重內心態度或行為禮節。'
          },
          {
            question: '若發現父母犯錯，孔子認為子女應如何處理？',
            answer: '子女應以委婉語氣勸諫父母，若父母不聽，仍要孝敬，不可違逆，心中雖憂但不應抱怨。'
          },
          {
            question: '孔子認為子女應該怎樣看待父母年紀？為甚麼？',
            answer: '子女應時刻記住父母年歲，一則為父母長壽而喜，一則為父母年老而憂，既珍惜天倫之樂，也關心父母健康。'
          },
          {
            question: '試分別說明君子能「無終食之間違仁」及「不憂不懼」的原因。',
            answer: '君子無論任何時候都不會背離仁道，因為堅守仁德，不受外在環境動搖。君子「不憂不懼」是因為常自省，問心無愧，自然無所憂懼。'
          },
          {
            question: '「君子」與「仁」有何關係？請說明。',
            answer: '君子每時每刻都堅持仁德，「君子無終食之間違仁」，失去仁就不配稱為君子。'
          },
          {
            question: '綜合全文，歸納「君子」與「小人」有何區別？',
            answer: '外在環境：君子安於本分，遵行仁道；小人則貪圖安樂，難耐貧困。心胸：君子坦蕩，小人多憂。待人：君子成人之美，小人促人為惡。責任：君子自責自省，小人推卸責任。'
          },
          {
            question: '「君子坦蕩蕩，小人長戚戚」、「君子求諸己，小人求諸人」這兩句用了什麼修辭？有何效果？',
            answer: '兩句均用對比和對偶手法，結構整齊，意義相對，突顯君子與小人特質，主旨明確，讀者印象深刻，便於記誦。'
          }
        ]
      }
    }
  },
  'hkdse-b3-analects-gentleman': {
    title: '《論語》論君子問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落重點整理',
        content: [
          {
            subtitle: '第一段：君子的品德與行為',
            points: [
              {
                title: '君子的基本特質',
                items: [
                  '君子為人莊重穩重，才會有威嚴。',
                  '學問要靠努力才能鞏固。',
                  '以忠信為主，慎選朋友。',
                  '有錯能改，不怕改過。'
                ]
              },
              {
                title: '君子與小人的分別',
                items: [
                  '君子坦蕩蕩，心胸寬廣；小人長戚戚，常常憂愁恐懼。',
                  '君子不憂不懼，因為內省無愧於心。',
                  '君子成全他人美事，不促成惡事；小人則相反。',
                  '君子以言行一致為恥，重承諾、講信用。',
                  '君子以道義為本，行事有禮，說話謙遜，守信實。',
                  '君子擔心自己能力不足，不擔心別人不認識自己。',
                  '君子責求諸己，小人責求於人。'
                ]
              }
            ]
          }
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '文言實詞——君子是否生來天賦異於常人？請加以說明。（2分）',
            answer: '君子並非天生有別於常人，而是在品德修養、學習態度及自我反省上不斷提升自己。正如孔子強調「君子求諸己，小人求諸人」，君子重視自我完善，並非靠天賦。'
          },
          {
            question: '作者以什麼東西作比喻，說明修身的重要？（4分）',
            answer: '文中沒有明顯的動物或器物比喻（如荀子《勸學》的舟、馬、蚓、蟹），但孔子以「君子坦蕩蕩，小人長戚戚」這種心理狀態的對比，及「君子病無能焉，不病人之不己知也」以行為動機作比，強調君子應專注自身修養，無需顧慮外界評價。'
          },
          {
            question: '本段的中心論點是什麼？請引用文中語句支持。（2分）',
            answer: '中心論點：君子應具備高尚品德，事事以道義為本，心胸光明磊落，嚴於律己。支持語句如：「君子坦蕩蕩，小人長戚戚」、「君子求諸己，小人求諸人」、「君子義以為質，禮以行之，孫以出之，信以成之」。'
          },
          {
            question: '歸納各段文意',
            answer: '論仁：如何看待貧富，以仁為本，安於現狀，堅守道德原則。論孝：孝的本質是「敬」，以禮待父母生死，存敬心，實踐孝道。論君子：君子的心理、行為、待人、責己等方面均有高標準，與小人形成對比。'
          },
          {
            question: '「君子曰」在全文中的作用是什麼？（1分）',
            answer: '「君子曰」作為語錄體開頭，標誌論述主體，使內容明確，突顯孔子語錄的權威性，方便讀者聚焦於主旨。'
          },
          {
            question: '文章如何運用對比論證？請加以說明。（5分）',
            answer: '心理狀態對比：「君子坦蕩蕩，小人長戚戚」——君子心安理得，小人則憂慮不安。責任歸屬對比：「君子求諸己，小人求諸人」——君子嚴於律己，小人則推卸責任。行為對比：「君子成人之美，不成人之惡。小人反是」——君子助人為善，小人則促人成惡。行事準則對比：「君子義以為質...信以成之」——君子以義為本，重禮信謙。這些對比論證突顯君子與小人各方面的差異，使主旨更鮮明，便於理解和記誦。'
          },
          {
            question: '學習《論語‧論君子》有何啟示？',
            answer: '提醒我們做人要有君子之風，無論心理、行為或待人處事都應嚴於律己，光明磊落，勇於改過，尊重他人，努力自省。這樣才能在社會立足，贏得他人尊重。'
          }
        ]
      }
    }
  }
};

export const getTypeBQAByTextId = (textId) => {
  return hkdseTypeBQAData[textId] || null;
}; 